var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 59C13.7076 59 0.5 45.7924 0.5 29.5C0.5 13.2076 13.7076 0 30 0C46.2924 0 59.5 13.2076 59.5 29.5C59.5 45.7924 46.2924 59 30 59ZM18.3844 21.5719C18.5687 21.7563 18.7531 22.125 18.7531 22.4938L18.7531 35.4C18.9375 35.9531 18.7531 36.3219 18.3844 36.6906L15.25 40.3781V40.9313L23.9156 40.9313V40.3781L20.7813 36.6906C20.5969 36.3219 20.4125 35.9531 20.4125 35.4L20.4125 24.1531L28.1563 40.9313H28.8937L35.5313 24.1531V37.6125C35.5313 37.9813 35.5313 38.1656 35.3469 38.35L32.95 40.7469V41.3H44.5656V40.7469L42.3531 38.5344C42.1688 38.35 42.1688 37.9813 42.1688 37.7969L42.1688 21.2031C41.9844 20.8344 42.1688 20.65 42.3531 20.4656L44.75 18.2531V17.7H36.6375L30.7375 32.2656L24.1 17.7H15.6188V18.2531L18.3844 21.5719Z",
    fill: "#9C7DF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.ae0b28a9929bfc5f68510ed5d698481f.svg";
export { ForwardRef as ReactComponent };